import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import React, { Suspense, lazy } from "react";
import { AuthProvider } from "./Context/AuthContext";
import ScrollToTop from "./App/components/ScrollToTop";
import PrivateRoute from "./App/routes/PrivateRoute";
import PublicLayout from "./App/routes/PublicRoutes";
import AdminLayout from "./App/Layouts/AdminLayout";
import Login from "./Context/Login";
import ProjectList from "./App/Admin Page/Project Module/ProjectList";
import ProjectCategoryList from "./App/Admin Page/Project Categeory Module/ProjectCategoryList";
import CareerList from "./App/Admin Page/Career Modal/CareerList";
import BannerList from "./App/Admin Page/Banner Module/BannerList";
import AdminUserList from "./App/components/Admin User/AdminUserList";
import GalleryList from "./App/Admin Page/Gallery Module/GalleryList";
import SubGalleryList from "./App/Admin Page/Sub Gallery Module/SubGalleryList";
import JobEnquiryList from "./App/Job Enquiry/JobEnquiryList";
import OtherServicesPage from "./App/Website Page/OtherServicesPage";

import UndergroundWaterSurveyDivision from "./App/Website Page/Services/UndergroundWaterSurveyDivision";
import CivilMaintenanceSoftware from "./App/Website Page/Services/CivilMaintenanceSoftware";
import TrafficSimulationAndSurveyDivision from "./App/Website Page/Services/TrafficSimulationAndSurveyDivision";
import AirportNocDivision from "./App/Website Page/Services/AirportNocDivision";
import BiometricSurveyDivision from "./App/Website Page/Services/BiometricSurveyDivision";
import AerialSurey from "./App/Website Page/Services/AerialSurey";


const WebsiteHome = lazy(() => import("./App/Website Page/WebsiteHome"));
const WebAbout = lazy(() => import("./App/Website Page/WebAbout"));
const WebContact = lazy(() => import("./App/Website Page/WebContact"));
const WebBlog = lazy(() => import("./App/Website Page/WebBlog"));
const WebBlogDetails = lazy(() => import("./App/Website Page/WebBlogDetails"));
const WebStrategicAdvisory = lazy(() => import("./App/Website Page/WebStrategicAdvisory"));
const WebHumanResourceConsulting = lazy(() => import("./App/Website Page/WebHumanResourceConsulting"));
const WebFinancialConsulting = lazy(() => import("./App/Website Page/WebFinancialConsulting"));
const WebConsumerResearch = lazy(() => import("./App/Website Page/WebConsumerResearch"));
const WebValuationStudies = lazy(() => import("./App/Website Page/WebValuationStudies"));
const WebIdentificationServices = lazy(() => import("./App/Website Page/WebIdentificationServices"));
const WebsiteProject = lazy(() => import("./App/Website Page/WebsiteProject"));
const WebTechnologies = lazy(() => import("./App/Website Page/WebTechnologies"));
const WebGallery = lazy(() => import("./App/Website Page/WebGallery"));
const WebCarrer = lazy(() => import("./App/Website Page/WebCarrer"));

// Services
const LandSurveyDivision = lazy(() => import("./App/Website Page/Services/LandSurveyDivision"));
const WaterSupplyDivision = lazy(() => import("./App/Website Page/Services/WaterSupplyDivision"));
const SewerageSystemDivision = lazy(() => import("./App/Website Page/Services/SewerageSystemDivision"));
const StormWaterDivisionSystem = lazy(() => import("./App/Website Page/Services/StormWaterDivisionSystem"));
const RainWaterHarvestingDivison = lazy(() => import("./App/Website Page/Services/RainWaterHarvestingDivison"));
const IrrigationDivision = lazy(() => import("./App/Website Page/Services/IrrigationDivision"));
const CompanySocietyMaintenanceDivision = lazy(() => import("./App/Website Page/Services/CompanySocietyMaintenanceDivision"));
const PropertyLiaisoningDivision = lazy(() => import("./App/Website Page/Services/PropertyLiaisoningDivision"));
const PropertyValuationDivision = lazy(() => import("./App/Website Page/Services/PropertyValuationDivision"));
const SoilInvestigation = lazy(() => import("./App/Website Page/Services/SoilInvestigation"));
const PropertyTaxSurveyDivision = lazy(() => import("./App/Website Page/Services/PropertyTaxSurveyDivision"));
const RoadDivision = lazy(() => import("./App/Website Page/Services/RoadDivision"));

// Admin Pages
const AdminDashboard = lazy(() => import("./App/Admin Page/AdminDashboard"));
const AdminEnquery = lazy(() => import("./App/Admin Page/AdminEnquery"));
const AdminBlog = lazy(() => import("./App/Admin Page/AdminBlog"));
function App() {
  return (
    <HelmetProvider>
    <Router>
            <AuthProvider> {/* Wrap everything inside AuthProvider */}
            <ScrollToTop />
            {/* <Suspense fallback={<div className="text-center p-5">Loading...</div>}> */}

      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<PublicLayout />}>
          <Route index element={<WebsiteHome />} />
          <Route path="about-us" element={<WebAbout />} />
          <Route path="project" element={<WebsiteProject />} />
          <Route path="our-technologies" element={<WebTechnologies />} />
          <Route path="gallery" element={<WebGallery />} />
          <Route path="career" element={<WebCarrer />} />
          <Route path="land-survey" element={<LandSurveyDivision />} />
          <Route path="water-supply" element={<WaterSupplyDivision />} />
          <Route path="sewerage-system" element={<SewerageSystemDivision />} />
          <Route path="drainage-system" element={<StormWaterDivisionSystem />} />
          <Route path="rain-water-harvesting" element={<RainWaterHarvestingDivison />} />
          <Route path="irrigation-system" element={<IrrigationDivision />} />
          <Route path="society-maintenance" element={<CompanySocietyMaintenanceDivision />} />
          <Route path="property-liaising" element={<PropertyLiaisoningDivision />} />
          <Route path="property-valuation" element={<PropertyValuationDivision />} />
          <Route path="biometric-survey" element={<BiometricSurveyDivision />} />


          <Route path="underground-water-survey" element={<UndergroundWaterSurveyDivision />} />
         
          <Route path="underground-water-survey-division" element={<UndergroundWaterSurveyDivision />} />
          <Route path="civil-maintenance-software" element={<CivilMaintenanceSoftware />} />
 <Route path="aerial-surey" element={<AerialSurey />} />
          <Route path="traffic-simulation-survey" element={<TrafficSimulationAndSurveyDivision />} />
          <Route path="airport-noc" element={<AirportNocDivision />} />


          <Route path="property-tax-survey" element={<PropertyTaxSurveyDivision />} />
          <Route path="other-service" element={<OtherServicesPage />} />
          <Route path="road-survey" element={<RoadDivision />} />
          <Route path="blogs" element={<WebBlog />} />
          <Route path="contact-us" element={<WebContact />} />
          <Route path="blogs-details/:id" element={<WebBlogDetails />} />
          <Route path="strategic-advisory" element={<WebStrategicAdvisory />} />
          <Route path="human-resource-consulting" element={<WebHumanResourceConsulting />} />
          <Route path="financial-consulting" element={<WebFinancialConsulting />} />
          <Route path="valuation-studies" element={<WebValuationStudies />} />
          <Route path="identification-services" element={<WebIdentificationServices />} />
          <Route path="consumer-research" element={<WebConsumerResearch />} />
          <Route path="soil-investigation" element={<SoilInvestigation />} />
        
        </Route>
          <Route path="login" element={<Login />} /> {/* Add Login Page */}

        {/* Private/Admin Routes */}
        <Route path="/admin" element={<PrivateRoute />}>
      <Route path="" element={<AdminLayout />}>
        <Route index element={<AdminDashboard />} />
        <Route path="users" element={<AdminEnquery />} />
        <Route path="blog" element={<AdminBlog />} />
        <Route path="project" element={<ProjectList />} />
        <Route path="project-category" element={<ProjectCategoryList />} />
        <Route path="career" element={<CareerList />} />
        <Route path="admin-user" element={<AdminUserList />} />
        <Route path="admin-job-enquiry" element={<JobEnquiryList />} />
        <Route path="banner" element={<BannerList />} />
        <Route path="gallery-category" element={<GalleryList />} />
        <Route path="gallery" element={<SubGalleryList />} />
      </Route>
    </Route>
      </Routes>

      {/* </Suspense> */}
      </AuthProvider>
    </Router>
    </HelmetProvider>
  );
}

export default App;
